import React from "react";

const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.83714 5.00065H14.1705L9.99548 10.2507L5.83714 5.00065ZM3.54548 4.67565C5.22881 6.83398 8.33714 10.834 8.33714 10.834V15.834C8.33714 16.2923 8.71214 16.6673 9.17048 16.6673H10.8371C11.2955 16.6673 11.6705 16.2923 11.6705 15.834V10.834C11.6705 10.834 14.7705 6.83398 16.4538 4.67565C16.8788 4.12565 16.4871 3.33398 15.7955 3.33398H4.20381C3.51214 3.33398 3.12048 4.12565 3.54548 4.67565Z" fill="#BE2BBB"/>
    </svg>
  );
};

export default FilterIcon;
